import "react-phone-input-2/lib/style.css";
import { Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import React, { useGlobal, useState } from "reactn";
import es from "react-phone-input-2/lang/es.json";
import moment from "moment";

import {
	CheckboxGroupContainer,
	CheckboxStyled,
	DatePickerStyled,
	FieldContainer,
	FieldStyled,
	TextAreaStyled,
} from "./styles";
import { getUserInfo } from "lib/getUserInfo";
import { pathOr } from "lib/functions";
import { validate as rutValidator, validateShortPhoneCl } from "lib/rut";
import { useTranslation } from "react-i18next";

const dniInputNames = [
	{ name: "rut", label: "RUT" },
	{ name: "dni", label: "DNI" },
];

export const Field = ({
	setPhoneCode,
	phoneCode,
	fieldType,
	_id: id,
	question: name,
	value,
	limit,
	register,
	validCharacter,
	required,
	validMessage,
	defaultField,
	errors,
	options,
	control,
	setValue,
	countryCode,
}) => {
	// const typeMap = type === "choice" ? "radio" : type;
	const [user] = useGlobal("user");
	const { t } = useTranslation("dinamicForm");

	const defaultValidationObj = {
		email: "[aA-zZ]",
		text: "[aA-zZ]",
	};
	const defaultValidation = defaultValidationObj[fieldType];
	const [dniInputName, setDniInputName] = useState("rut");
	const [inputs, setInputs] = useState({ code: "+56" });
	const onChangeInputs = ({ target, input, value }) => {
		if (target.name === "code") {
			return setPhoneCode(target.value);
		}
		if (target && target.name === "inputName") {
			setDniInputName(target.value);
			return setInputs((i) => ({
				...i,
				[target.name]: target.value,
				["rut"]: "",
				["dni"]: "",
			}));
		}
	};

	//TODO: Add validation for phone number and RUT | FIX fieldType Checkbox
	const hasErrorInThisFiled = pathOr(
		false,
		[fieldType === "checkbox" ? fieldType : id],
		errors
	);

	const userInfo = getUserInfo(user, id);
	const valid =
		validCharacter && !validCharacter.length && defaultField
			? new RegExp("[aA-zZ]")
			: new RegExp(validCharacter);

	const renderSwitch = (type) => {
		const lastType =
			fieldType === "select" ||
			fieldType === "email" ||
			fieldType === "textarea" ||
			fieldType === "date" ||
			fieldType === "checkbox"
				? fieldType
				: type;

		switch (lastType) {
			case "Rut/Dni" || "Rut" || "Dni":
				return (
					<>
						<div className="input__phone-container">
							<FieldStyled
								hasErrorInThisFiled={hasErrorInThisFiled}
								fieldName={id}
								type={fieldType}
								{...register(name, {
									required: required,
									maxLength: parseInt(limit),
									pattern: {
										value: dniInputName === "dni" && valid,
										message:
											validMessage ||
											t("rutValidationMsg"),
									},
									minLength: 1,
									validate: {
										RUT: (value) =>
											dniInputName === "rut"
												? rutValidator(value)
												: true || validMessage,
									},
								})}
							/>

							<select
								className="input__select"
								name={"inputName"}
								onChange={onChangeInputs}
								value={inputs.inputName || "rut"}
							>
								{dniInputNames &&
									dniInputNames.map((name) => (
										<option
											key={name.name}
											value={name.name}
										>
											{name.label}
										</option>
									))}
							</select>
						</div>
						{hasErrorInThisFiled && (
							<span className="error-label">
								{validMessage || t("rutValidationMsg")}
							</span>
						)}
					</>
				);
			case "Teléfono" || "Phone" || "tel":
				return (
					<>
						<div className="input__phone-container">
							<Controller
								control={control}
								name={id}
								rules={{
									required: required,
									maxLength: 12,
									pattern: {
										value: phoneCode !== "+56" && valid,
										message:
											validMessage ||
											t("phoneValidationMsg"),
									},
									minLength: !required ? 0 : 9,
									validate: {
										CLPhone: (value) =>
											phoneCode === "+56"
												? validateShortPhoneCl(
														value,
														required
												  )
												: true || validMessage,
									},
								}}
								render={({ field: { ref, ...field } }) => (
									<PhoneInput
										value={phoneCode || "+56"}
										regions={[
											"america",
											"europe",
											"asia",
											"oceania",
											"africa",
										]}
										countryCodeEditable={false}
										localization={es}
										preferredCountries={[
											"cl",
											"co",
											"pe",
											"ar",
										]}
										autoFormat={false}
										country={countryCode}
										buttonStyle={{
											backgroundColor: "transparent",
											border: hasErrorInThisFiled
												? "1px solid #ff4d4f"
												: "1px solid #e6e6e6",
											borderTopLeftRadius: "8px",
											borderBottomLeftRadius: "8px",
											"&:hover": {
												borderRadius: "8px",
											},
										}}
										searchStyle={{
											width: "100%",
										}}
										inputStyle={{
											fontFamily: "Montserrat",
											border: hasErrorInThisFiled
												? "1px solid #ff4d4f"
												: "1px solid #e6e6e6",
											width: "100%",
											height: "40px",
											borderRadius: "8px",
										}}
										{...field}
										inputExtraProps={{
											ref,
											required: required,
											autoFocus: true,
										}}
									/>
								)}
							/>
						</div>
						{hasErrorInThisFiled && (
							<span className="error-label">
								{validMessage || t("phoneValidationMsg")}
							</span>
						)}
					</>
				);
			case "select":
				return (
					<>
						<select
							className="input__select-forms"
							data-has-error-in-this-field={hasErrorInThisFiled}
							data-field-name={id}
							type={fieldType}
							{...register(id, {
								required: required,
								maxLength: parseInt(limit),
							})}
						>
							{options.map((el, index) => (
								<option key={index}>{el}</option>
							))}
						</select>

						{hasErrorInThisFiled && (
							<span className="error-label">{validMessage}</span>
						)}
					</>
				);
			case "email":
				return (
					<>
						<FieldStyled
							hasErrorInThisFiled={hasErrorInThisFiled}
							fieldName={id}
							type="email"
							{...register(id, {
								required: required,
								minLength: 2,
								pattern: {
									value: valid,
									message: validMessage,
								},
								value: userInfo,
							})}
						/>
						{hasErrorInThisFiled && (
							<span className="error-label">
								{validMessage || t("infoNecesary")}
							</span>
						)}
					</>
				);
			case "textarea":
				return (
					<>
						<Controller
							name={id}
							rules={{
								required: required,
							}}
							control={control}
							render={({ field: { ...field } }) => (
								<TextAreaStyled
									status={hasErrorInThisFiled ? "error" : ""}
									{...field}
								/>
							)}
						/>

						{hasErrorInThisFiled && (
							<span className="error-label">
								{validMessage || t("infoNecesary")}
							</span>
						)}
					</>
				);
			case "checkbox":
				if (options.length) {
					return (
						<>
							<Controller
								name={id}
								rules={{
									required: required,
								}}
								control={control}
								render={({ field: { onChange } }) => (
									<CheckboxGroupContainer>
										<CheckboxStyled.Group
											options={options.map((option) => ({
												label: option,
												value: option,
											}))}
											onChange={(checkedValues) => {
												onChange(
													checkedValues.join(", ")
												);
											}}
										/>
									</CheckboxGroupContainer>
								)}
							/>

							{hasErrorInThisFiled && (
								<p className="error-label">
									{validMessage || t("infoNecesary")}
								</p>
							)}
						</>
					);
				}
				return (
					<>
						<Controller
							name={fieldType}
							rules={{
								required: required,
							}}
							control={control}
							render={({ field: { onChange } }) => (
								<CheckboxStyled
									onChange={({ target: { checked } }) => {
										onChange(checked);
									}}
								>
									{t("acceptPolicy")}
								</CheckboxStyled>
							)}
						/>

						{hasErrorInThisFiled && (
							<p className="error-label">
								{validMessage || t("infoNecesary")}
							</p>
						)}
					</>
				);
			case "date":
				return (
					<>
						<Controller
							name={id}
							rules={{
								required: required,
							}}
							control={control}
							render={({
								field: { onChange, value, ...field },
							}) => (
								<DatePickerStyled
									{...field}
									status={hasErrorInThisFiled ? "error" : ""}
									value={
										value
											? moment(value, "DD/MM/YYYY")
											: null
									}
									onChange={(date, dateString) =>
										onChange(dateString)
									}
									placeholder={t("selectDate")}
									format="DD/MM/YYYY"
								/>
							)}
						/>
						{hasErrorInThisFiled && (
							<span className="error-label">
								{validMessage || t("infoNecesary")}
							</span>
						)}
					</>
				);
			default:
				return (
					<>
						<Controller
							name={id}
							rules={{
								required: required,
								maxLength: parseInt(limit),
								pattern: {
									value: valid,
									message: validMessage,
								},
							}}
							control={control}
							render={({ field: { ...field } }) => (
								<FieldStyled
									hasErrorInThisFiled={hasErrorInThisFiled}
									{...field}
								/>
							)}
						/>

						{hasErrorInThisFiled && (
							<span className="error-label">
								{validMessage || t("infoNecesary")}
							</span>
						)}
					</>
				);
		}
	};

	return (
		<FieldContainer
			fieldName={name}
			key={id}
			hasErrorInThisFiled={hasErrorInThisFiled}
		>
			<div className={"dynamic-input-field-label"}>
				{name}
				<span className="opcional-label">
					{" "}
					{!required && t("optional")}
				</span>
			</div>
			{renderSwitch(name)}
		</FieldContainer>
	);
};
